import * as Yup from 'yup';

import validateSubscriptionEmail from '@utils/validateSubscriptionEmail';

const validationSchema = () =>
  Yup.object().shape({
    email: validateSubscriptionEmail(),
  });

export default validationSchema;
